module.exports = {"653001001":"幸福路街道","653001002":"光明路街道","653001003":"新城街道","653001100":"上阿图什镇","653001200":"松他克乡","653001201":"阿扎克乡","653001202":"阿湖乡","653001204":"格达良乡","653001205":"哈拉峻乡","653001206":"吐古买提乡","653001500":"兵团农三师红旗农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653001.json
// module id = 3243
// module chunks = 0